import { render, staticRenderFns } from "./CallControls.vue?vue&type=template&id=f82eb53c"
import script from "./CallControls.vue?vue&type=script&lang=js"
export * from "./CallControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports